import React, { ReactNode } from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Text from 'components_new/atoms/Text'

import SectionHeader, {
  SectionHeaderProps
} from 'components_new/molecules/SectionHeader'

import { useTranslation } from 'language/translator'

export type TImportance = 'optional' | 'recommended' | 'required'

export interface FormSectionProps {
  actions?: ReactNode
  children?: ReactNode
  disableMargin?: boolean
  divider?: boolean
  helperText?: ReactNode
  iconTip?: SectionHeaderProps['iconTip']
  importance?: TImportance
  sx?: SxProps
  size?: 'small' | 'medium' | 'large'
  title: string
  titleAdornment?: ReactNode
}

const FormSection = React.forwardRef((props: FormSectionProps, ref: any) => {
  const {
    actions,
    children,
    disableMargin,
    divider,
    helperText,
    iconTip,
    importance,
    size = 'medium',
    sx,
    title,
    titleAdornment
  } = props

  const { t } = useTranslation()

  const getMargin = () => {
    if (disableMargin) return undefined

    switch (size) {
    case 'small':
      return 2
    default:
      return 4
    }
  }

  return (
    <Box
      ref={ref}
      sx={{
        '&:not(:last-child)': {
          mb: getMargin()
        },
        ...sx
      }}
    >
      <SectionHeader
        actions={actions}
        divider={divider}
        gutterBottom={Boolean(children)}
        helperText={helperText}
        iconTip={iconTip}
        size={size}
        title={
          <>
            {title}
            {importance ? (
              <Text
                color="text.secondary"
                component="span"
                lineHeight="inherit"
                sx={{ ml: '0.25em' }}
              >
                ({t('global', importance)})
              </Text>
            ) : null}
          </>
        }
        titleAdornment={titleAdornment}
      />
      {children}
    </Box>
  )
})

FormSection.displayName = 'FormSection'
export default FormSection
